<template>
  <b-card no-body class="research-reports-card w-100 mt-1">
    <b-card-body class="d-flex flex-column p-0 h-100">
      <div class="report-header">
        <img
          class="report-header-icon"
          src="@/assets/images/portfolio/ResearchReports.svg"
          alt="1"
        />
        <h4 class="card-title report-header-title">Research Reports</h4>
      </div>
      <simplebar class="activity-feed report-simplebar" data-simplebar>
        <div>
          <div
            v-for="(report, index) in reports"
            :key="index"
            class="report-item"
          >
            <a :href="report.link" target="_blank">
              <img
                :src="report.image"
                class="report-image"
                :alt="report.title"
              />
            </a>
            <a :href="report.link" target="_blank">
              <div class="report-info">
                <p class="report-text">{{ report.title }}</p>
                <span class="report-meta">{{ report.date }}</span>
              </div>
            </a>
          </div>
        </div>
      </simplebar>
      <div
        :class="{
          actions: true,
          'actions-prp':
            isPortfolioEmpty &&
            (planType == 'Prime Growth' ||
              planType == 'Prime Essentials' ||
              planType === 'Prime-registered' || planType === 'Active'),
        }" class="mb-2"
      >
        <a
          :href="`${baseURL}/my-favourites/`"
          class="favorite-button-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="favorite-button">
            <img src="@/assets/images/portfolio/Star.png" alt="star" />My
            Favourites
          </span>
        </a>
        <a
          :href="`${baseURL}/category/all-categories/`"
          class="view-funds-link"
          target="_blank"
          rel="noopener noreferrer"
          >View All</a
        >
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import simplebar from "simplebar-vue";
import { mapGetters } from "vuex";

export default {
  components: { simplebar },
  data() {
    return {
      reports: [],
      baseURL: process.env.VUE_APP_BASE_URL,
    };
  },
  watch: {
    researchReports: {
      handler(newValue) {
        this.processFetchedData(newValue);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["researchReports", "planType", "myPortfolio"]),
    isPortfolioEmpty() {
      return Object.keys(this.myPortfolio).length === 0;
    },
  },
  methods: {
    processFetchedData(data) {
      try {
        if (Object.keys(data).length > 0) {
          this.reports = data.map((report) => ({
            image: report.post_thumbnail,
            title: report.title,
            author: report.author,
            date: report.date,
            link: report.link,
          }));
        }
      } catch (error) {
        console.error("Error processing data:", error);
      }
    },
  },
};
</script>

<style scoped>
.research-reports-card {
  background: linear-gradient(180deg, #ffffff 0%, #feffba 100%);
}

@media (min-width: 992px) {
  .research-reports-card {
    height: 572px;
  }
}

.report-header {
  position: relative;
  padding: 10px;
  margin-bottom: 7px;
}

.report-header-icon {
  position: relative;
  top: 5px;
  left: 6px;
  height: 35px;
  width: 30px;
}

.report-header-title {
  position: absolute;
  left: 54px;
  top: 22px;
}

.activity-feed {
  padding-right: 10px;
}

.report-item {
  display: flex;
  align-items: center;
  margin-top: 10px;
  position: relative;
  padding-right: 5px;
  padding-left: 20px;
}

.report-info:hover .report-text,
.report-info:hover .report-meta {
  color: #00a3d9;
}

.report-meta {
  color: #696969;
  margin-top: 5px;
  font-size: 12px;
}

.report-image {
  width: 89px;
  height: 60px;
  margin-right: 10px;
  border-radius: 5px;
  max-width: unset;
}

.report-info {
  flex: 1;
}

.report-text {
  color: #012e40;
  margin: 0;
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 18px 0px 16px;
}

.actions-prp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 18px 10px 16px;
}

@media (max-width: 990px) {
  .actions {
    padding: 13px 18px 10px 16px;
  }
}

.favorite-button {
  display: flex;
  align-items: center;
  padding: 2px 4px;
  border: 1px solid rgb(0, 163, 217);
  border-radius: 5px;
  font-size: 12px;
}

.favorite-button img {
  margin-right: 5px;
}

.view-funds-link {
  font-size: 12px;
}

.report-simplebar {
  flex: 1 1 auto;
  min-height: 280px;
  margin-top: -10px;
}

@media (max-width: 991px) {
  .report-simplebar {
    min-height: unset;
    max-height: 280px;
  }

  .activity-feed {
    max-height: 280px;
  }
}

@media (max-width: 600px) {
  .report-item {
    align-items: flex-start;
  }

  .report-image {
    height: auto;
    margin-bottom: 10px;
  }

  .report-text {
    font-size: 12px;
  }
}
</style>
